import { UserList } from './Components/UserList';

const UserManagement = () => {
  return <UserList />;
};

export { UserManagement };
